
import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button } from "antd";
import { ApiURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";


const Bugs = () => {
  const [page_loader, set_page_loader] = useState(true);
  const [ship_id, set_ship_id] = useState(null);
  const [ship_table_list, set_ship_table_list] = useState([]);
  const [bugsData, setBugsData] = useState([]);

  /* ---------------- SHIP LIST API ---------------- */
  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
      if (res?.status === true) {
        set_ship_table_list(res?.ships || []);
        BUG_LIST_API();
      }
    });
  };

  /* ---------------- BUG LIST API ---------------- */
  const BUG_LIST_API = (shipId = null) => {
    set_page_loader(true);
    const FORM_DATA = new FormData();

    if (shipId) FORM_DATA.append("ship_id", shipId);

    post(ApiURL.company_bug_report_list_com, FORM_DATA)
      .then((res) => {
        if (res?.status === true) {
          setBugsData(res?.data || []);
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .finally(() => set_page_loader(false));
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  /* ---------------- DESCRIPTION MODAL ---------------- */
  const [descrModal, setDescrModal] = useState({
    visible: false,
    text: "",
  });

  const showDescription = (record) => {
    setDescrModal({
      visible: true,
      text: record.description,
    });
  };

  /* ---------------- ATTACHMENT MODAL ---------------- */
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    url: "",
  });

  // const showAttachment = (path) => {
  //   setAttachmentModal({
  //     visible: true,
  //     url: `${BASE_URL}${path}`,
  //   });
  // };

  const showAttachment = (path) => {
  setAttachmentModal({
    visible: true,
    url: path,
  });
};

  /* ---------------- TABLE COLUMNS ---------------- */
  const columns = [
    {
      title: "Bug ID",
      dataIndex: "bug_id",
      align: "center",
    },
    {
      title: "Title",
      dataIndex: "title",
      align: "center",
    },

    /* ✅ DESCRIPTION COLUMN */
    {
      title: "Description",
      align: "center",
      render: (record) => (
        <Button type="link" onClick={() => showDescription(record)}>
          View
        </Button>
      ),
    },

    {
      title: "Severity",
      dataIndex: "severity_label",
      align: "center",
      render: (text) => (
        <span
          style={{
            color:
              text === "High" || text === "Critical"
                ? "red"
                : text === "Medium"
                ? "orange"
                : "green",
            fontWeight: "bold",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      render: (text) => formatDate(text),
    },

    /* ✅ ATTACHMENT COLUMN */
    {
      title: "Attachment",
      align: "center",
      render: (record) =>
        record?.attachment ? (
          <Button
            type="link"
            onClick={() => showAttachment(record.attachment)}
          >
            View
          </Button>
        ) : (
          "—"
        ),
    },
    {
      title: "Ship Name",
      dataIndex: "ship_name",
      align: "center",
    },
  ];

  return (
    <div>
      {/* ---------------- Ship Selection ---------------- */}
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>

          <Select
            placeholder="All Ships"
            style={{ width: "100%" }}
            value={ship_id}
            allowClear
            onChange={(value) => {
              set_ship_id(value);
              BUG_LIST_API(value);
            }}
          >
            {ship_table_list.map(
              (ship) =>
                !ship.soft_delete && (
                  <Select.Option key={ship.id} value={ship.id}>
                    {ship.vessel_name}
                  </Select.Option>
                )
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6">
          <h3>Bugs Report List</h3>
        </div>
      </div>

      <Table
        bordered
        columns={columns}
        dataSource={bugsData}
        loading={page_loader}
        pagination={{ pageSize: 10 }}
        rowKey="id"
        className="custom-table"
      />

      {/* -------- DESCRIPTION MODAL -------- */}
      <Modal
        title="Description"
        open={descrModal.visible}
        footer={null}
        onCancel={() => setDescrModal({ visible: false, text: "" })}
      >
        <p>{descrModal.text}</p>
      </Modal>

      {/* -------- ATTACHMENT MODAL -------- */}
      <Modal
        title="Attachment Preview"
        open={attachmentModal.visible}
        footer={null}
        width={700}
        onCancel={() =>
          setAttachmentModal({ visible: false, url: "" })
        }
      >
        <img
          src={attachmentModal.url}
          alt="Attachment"
          style={{ width: "100%", borderRadius: "6px" }}
        />
      </Modal>
    </div>
  );
};

export default Bugs;
